module.exports = __webpack_public_path__ + "img/add.5e5091b1.svg";